import styled from 'styled-components';

export const BannerCounterContainer = styled.div<{ isXS: boolean }>`
	display: flex;
	${({ isXS }) => (isXS ? 'gap: 6px;' : 'gap: 12px;')}
	direction: ltr;
`;
